import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { ref, onMounted, onBeforeUnmount } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Snackbar',
  props: {
    message: {}
  },
  emits: ["dismiss"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const visible = ref(false);
let timer: ReturnType<typeof setTimeout> | null = null;

function dismiss() {
  visible.value = false;
}

onMounted(() => {
  visible.value = true;
  timer = setTimeout(dismiss, 5000);
});

onBeforeUnmount(() => {
  if (timer) {
    clearTimeout(timer);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    name: "slide-up",
    onAfterLeave: _cache[0] || (_cache[0] = ($event: any) => (emit('dismiss')))
  }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "snackbar",
            onClick: dismiss
          }, _toDisplayString(_ctx.message), 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})